module.exports = __webpack_public_path__ + "Card1-Ethnography.png?b5e63389ce81e27d18223f75b7745fd1";


//////////////////
// WEBPACK FOOTER
// ./static/Card1-Ethnography.png
// module id = 342
// module chunks = 0